import $ from 'jquery'
import { View } from 'backbone.marionette'
import Product from '../models/product'

let ProductTrimsView
export default ProductTrimsView = (function () {
  ProductTrimsView = class ProductTrimsView extends View {
    static initClass() {
      this.prototype.ui = {
        trimSets: '.trim-set',
        trimContainers: '.trim-container',
        trimImages: '.trim-image'
      }

      this.prototype.events = {
        'click .trim-container': 'trimClicked'
      }

      this.prototype.modelEvents = {
        'change:substrate': 'substrateChanged',
        'change:quantity': 'quantityChanged'
      }
    }

    substrateChanged() {
      const newSubstrate = this.model.get('substrateEnumName')

      // Hide all trims
      this.ui.trimSets.hide()

      // Show trims related to this format substrate
      const $newTrimSet = this.$(
        '.trim-set[data-format-substrate=' + newSubstrate + ']'
      )
      if ($newTrimSet.length) {
        $newTrimSet.show()
      }

      // Unselect all trims
      const selectedTrimPrinterCode = this.$('.trim-container.selected').data(
        'trimPrinterCode'
      )
      this.ui.trimContainers.removeClass('selected')
      this.ui.trimImages.removeClass('active')

      // Select the previously-selected trim in the new substrate
      if ($newTrimSet.length) {
        return $newTrimSet
          .find(
            '.trim-container[data-trim-printer-code=' +
              selectedTrimPrinterCode +
              ']'
          )
          .addClass('selected')
          .find(
            '.trim-image[data-trim-printer-code=' +
              selectedTrimPrinterCode +
              ']'
          )
          .addClass('active')
      }
    }

    trimClicked(e, options) {
      this.ui.trimContainers.removeClass('selected')
      this.ui.trimImages.removeClass('active')

      const $trimContainer = $(e.target).closest('.trim-container')
      $trimContainer.addClass('selected').find('.trim-image').addClass('active')
      this.selectTrim($trimContainer, options)
    }

    selectTrim(trimContainer, options) {
      const itemId = trimContainer.data('itemid')
      if (!itemId) {
        return this.model.unset('trim')
      } else {
        return this.model.set(
          'trim',
          new Product({
            id: itemId,
            quantity: this.model.get('quantity')
          }),
          { silent: options ? options.silent : false }
        )
      }
    }

    quantityChanged() {
      const currentTrim = this.model.get('trim')
      if (currentTrim) {
        return currentTrim.set('quantity', this.model.get('quantity'))
      }
    }

    initialize() {
      // View takes precedence over model. At initialization time, set the model to whatever the view has.
      // This allows our model to parse whatever the user selected before our JavaScript initializes.
      const $selectedTrim = this.$el.find('.selected')
      return $selectedTrim.trigger('click', [{ silent: true }])
    }
  }
  ProductTrimsView.initClass()
  return ProductTrimsView
})()
